import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import notify from "../../../../Notifcation";
import { useDispatch, useSelector } from "react-redux";
import { createApplicationAction } from "../../../../redux/actions/ApplicationAction";
import { Container, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import dayjs from "dayjs";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
// import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
const Ticket = () => {
  const [passpor, setpasspor] = useState([]);
  const [tickektNumber, settickektNumber] = useState("");
  const [TicketsType, setTicketsType] = useState("");
  const [TicketsTypeHagz, setTicketsTypeHagz] = useState("");
  const [fromLoc, setfromLoc] = useState("");
  const [toLoc, settoLoc] = useState("");
  const [FormDate, setFormDate] = useState("");
  const [toDate, settoDate] = useState("");
  const [loading, setLoading] = useState(true);
  const [isPress, setisPress] = useState(false);
  const navegate = useNavigate();
  const yesterday = dayjs().subtract(1, "day");
  // useEffect(() => {
  //   dispatch(getCarByIdAction(idcar));
  // }, [idcar]);

  const dispatch = useDispatch();
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (
      TicketsType === "" ||
      tickektNumber === "" ||
      fromLoc === "" ||
      toLoc === "" ||
      TicketsTypeHagz === "from"
        ? FormDate === ""
        : TicketsTypeHagz === "to"
        ? toDate === ""
        : TicketsTypeHagz === "fromto"
        ? FormDate === "" || toDate === ""
        : null
    ) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setisPress(true);
    const formData = new FormData();
    formData.append("application_type", 2);
    formData.append("ticket_type", TicketsType);
    formData.append("tickets_number", tickektNumber);
    formData.append("from_location", fromLoc);
    formData.append("to_location", toLoc);
    formData.append("from_date", TicketsTypeHagz==='from'||TicketsTypeHagz==='fromto'?FormDate:"");
    formData.append("to_date", TicketsTypeHagz==='to'||TicketsTypeHagz==='fromto'?toDate:"");
    passpor.map((item) => {
      return formData.append("passports", item);
    });
    await dispatch(createApplicationAction(formData));
    setLoading(false);
    setpasspor("");
    settickektNumber("");
    setFormDate("");
    setTicketsType("");
    setfromLoc("");
    settoDate("");
    settoLoc("");
    settickektNumber("");

    setisPress(false);
  };
  const handleFileChangePasspor = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setpasspor(files);
  };
  const res = useSelector((state) => state.ApplicationReduser.createApp);
  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1500);
      if (res) {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            notify(res.data.message, "success");
            setTimeout(() => {
              navegate("/user/requestsuser");
            }, 3000);
          }
        } else if (res.status !== 200 || res.status !== 201) {
          if (res.data) {
            notify(res.data.message, "error");
          } else {
            notify("حدثة مشكلة حاول مرة اخرى", "error");
          }
        }
      }
    }
  }, [loading]);
  return (
    <div>
      <Container>
        {" "}
        <h3 className="text-center mb-3 mt-3">حجز تذكرة الطيران </h3>
        <div className="inputs-container">
          <div className="inp-container ">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                <Typography>
                  نوع التذكرة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label={
                  <Typography>
                    نوع التذكرة
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                value={TicketsType}
                onChange={(e) => setTicketsType(e.target.value)}
              >
                <MenuItem value={"transient"}>ترانزيت</MenuItem>
                <MenuItem value={"direct"}>مباشر</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="inp-container ">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                <Typography>
                  نوع التذكرة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label={
                  <Typography>
                    نوع التذكرة
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                value={TicketsTypeHagz}
                onChange={(e) => setTicketsTypeHagz(e.target.value)}
              >
                <MenuItem value={"from"}>ذهاب</MenuItem>
                <MenuItem value={"to"}>عودة</MenuItem>
                <MenuItem value={"fromto"}>ذهاب وعودة</MenuItem>
              </Select>
            </FormControl>
          </div>
          {TicketsTypeHagz === "from" ? (
            <>
              {" "}
              <div className="inp-container ">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoItem>
                    <DateTimePicker
                      label={
                        <Typography>
                          ذهاب
                          <span style={{ color: "red", fontSize: "21px" }}>
                            *
                          </span>
                        </Typography>
                      }
                      defaultValue={yesterday}
                      onChange={(e) => setFormDate(e)}
                      disablePast
                      views={["year", "month", "day", "hours", "minutes"]}
                    />
                  </DemoItem>
                </LocalizationProvider>
              </div>
            </>
          ) : TicketsTypeHagz === "to" ? (
            <>
              {" "}
              <div className="inp-container ">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoItem>
                    <DateTimePicker
                      label={
                        <Typography>
                          عودة
                          <span style={{ color: "red", fontSize: "21px" }}>
                            *
                          </span>
                        </Typography>
                      }
                      defaultValue={yesterday}
                      onChange={(e) => settoDate(e)}
                      disablePast
                      views={["year", "month", "day", "hours", "minutes"]}
                    />
                  </DemoItem>
                </LocalizationProvider>
              </div>
            </>
          ) : TicketsTypeHagz === "fromto" ? (
            <>
              {" "}
              <div className="inp-container ">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoItem>
                    <DateTimePicker
                      label={
                        <Typography>
                          ذهاب
                          <span style={{ color: "red", fontSize: "21px" }}>
                            *
                          </span>
                        </Typography>
                      }
                      defaultValue={yesterday}
                      onChange={(e) => setFormDate(e)}
                      disablePast
                      views={["year", "month", "day", "hours", "minutes"]}
                    />
                  </DemoItem>
                </LocalizationProvider>
              </div>
              <div className="inp-container ">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoItem>
                    <DateTimePicker
                      label={
                        <Typography>
                          عودة
                          <span style={{ color: "red", fontSize: "21px" }}>
                            *
                          </span>
                        </Typography>
                      }
                      defaultValue={yesterday}
                      onChange={(e) => settoDate(e)}
                      disablePast
                      views={["year", "month", "day", "hours", "minutes"]}
                    />
                  </DemoItem>
                </LocalizationProvider>
              </div>
            </>
          ) : null}

          <div className="inp-container ">
            <TextField
              focused
              label={
                <Typography>
                  الدولة من
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              onChange={(e) => setfromLoc(e.target.value)}
              variant="outlined"
              value={fromLoc}
              type="text"
            />
          </div>
          <div className="inp-container ">
            <TextField
              focused
              label={
                <Typography>
                  الدولة إلى
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              onChange={(e) => settoLoc(e.target.value)}
              variant="outlined"
              value={toLoc}
              type="text"
            />
          </div>
          <div className="inp-container ">
            <TextField
              focused
              label={
                <Typography>
                  عدد التذاكر
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              onChange={(e) => settickektNumber(e.target.value)}
              variant="outlined"
              value={tickektNumber}
              type="number"
            />
          </div>
          <div className="inp-container ">
            <TextField
              label="جواز السفر"
              focused
              type="file"
              inputProps={{
                multiple: true,
              }}
              onChange={handleFileChangePasspor}
              variant="outlined"
            />
          </div>

          <div className="inp-container "></div>
          <div className="inp-container "></div>
        </div>
        {isPress && loading ? (
          <button className="buttonadd">
            <Spinner />
          </button>
        ) : (
          <button className="buttonadd" onClick={handlesubmit}>
            {" "}
            استكمال الطلب
          </button>
        )}
        <ToastContainer />
      </Container>
    </div>
  );
};

export default Ticket;
